import { OpportunitiesConst } from '@axiom/const';

import selectifyUtil from '../../utils/selectify-util';
import { OPPORTUNITY_STAGE_OPTIONS } from '../../utils/opportunity-util';

export const opportunityStageFilterName = 'filters.stageCode';
export const opportunityBusinessTeamFilterName = 'filters.businessTeam';

export const opportunityStageSelectItems = selectifyUtil({
  groupLabel: 'Opportunity Stage',
  group: opportunityStageFilterName,
  options: OPPORTUNITY_STAGE_OPTIONS,
});

export const opportunityBusinessTeamSelectItems = selectifyUtil({
  groupLabel: 'Business Team',
  group: opportunityBusinessTeamFilterName,
  options: OpportunitiesConst.BusinessTeams,
});
